import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {TvShopStateService} from '../../services/state/tv-shop-state.service';
import {Order} from '../../model/order';
import {
  OrderingModalManagerComponent
} from '../../modals/ordering-modals/ordering-modal-manager/ordering-modal-manager.component';
import {TvShopEntertainmentPack} from '../../model/tv-shop-entertainment-pack';
import {NavigableComponent} from '../../model/navigable-component';
import {NavigationService} from '../../services/navigation/navigation.service';
import {PageNames} from '../page-names.enum';
import {AnalyticsService} from '../../services/analytics/analytics.service';
import {Router} from '@angular/router';
import {OrderOption} from '../../model/order-option';
import {DtvCatalogUtils} from '../../utils/dtv-catalog/dtv-catalog.utils';
import {PackOptionUtils} from '../utils/entertainmentpack/pack-option-utils';

@Component({
  selector: 'app-pack-option-selection',
  templateUrl: './pack-option-selection.component.html',
  styleUrls: ['./pack-option-selection.component.less']
})
export class PackOptionSelectionComponent extends NavigableComponent implements OnInit, AfterViewInit, OnDestroy {
  order: Order;
  omapiId: string;
  tvShopEntertainmentPacks: TvShopEntertainmentPack[];
  selectedTvShopEntertainmentPack: TvShopEntertainmentPack;

  packOptions: Array<OrderOption>;

  componentName = PageNames.PACK_OPTION_SELECTION;

  @ViewChild('packOptionsRef', {read: ElementRef})
  packOptionsRef: ElementRef;

  @ViewChild('orderModal')
  private orderingModal: OrderingModalManagerComponent;

  constructor(
    protected navigationService: NavigationService,
    private changeDetector: ChangeDetectorRef,
    private analyticsService: AnalyticsService,
    private stateService: TvShopStateService,
    private router: Router
  ) {
    super(navigationService);

    this.tvShopEntertainmentPacks = this.stateService.selectSnapshot(state => state.tvShopEntertainmentPacks);
    this.selectedTvShopEntertainmentPack = stateService.selectSnapshot(state => state.basket.selectedTvShopEntertainmentPack);
    this.omapiId = this.selectedTvShopEntertainmentPack.omapiId;
    this.packOptions = PackOptionUtils.getCorrectSetOfOptions(this.omapiId);
    this.enrichOptions();

    this.order = new Order(
      this.selectedTvShopEntertainmentPack.omapiId,
      this.selectedTvShopEntertainmentPack.priceDetail.price.value,
      null,
      null
    );
  }

  ngOnInit() {
    this.navigationService.setCurrentPageComponent(PageNames.PACK_OPTION_SELECTION);
    this.analyticsService.onDetailPage([this.selectedTvShopEntertainmentPack.omapiId]);
  }

  ngAfterViewInit() {
    this.changeDetector.detectChanges();
    this.navigationService.registerPageElement(this.packOptionsRef);
    this.navigationService.resetNavigation();
  }

  ngOnDestroy() {
    this.navigationService.clearNavigation();
  }

  enrichOptions() {
    this.packOptions.forEach(option => {
      option.omapiId = this.omapiId;
      option.pack = DtvCatalogUtils.getTvShopEntertainmentPackForOmapiId(this.tvShopEntertainmentPacks, option.omapiId);
      option.priceDetail = DtvCatalogUtils.getPriceForProduct(this.tvShopEntertainmentPacks, option.omapiId);
    });
  }

  onEmitOrderProduct(order: Order) {
    this.order = order;
    this.stateService.setTvShopEntertainmentPack(DtvCatalogUtils.getStreamingServicesOptionForOmapiId(this.tvShopEntertainmentPacks, order.packOmapiId));
    this.orderingModal.openModal();
  }

  onBack() {
    this.navigationService.resetNavigation();
    this.navigationService.clearNavigation();
    this.routeOnBackPressed();
  }

  private routeOnBackPressed() {
    this.router.navigate(['/product-details/' + this.omapiId], {queryParamsHandling: 'merge'});
  }
}
